import React, { createContext, useContext, useState, useCallback } from 'react';

interface MessagesActiveContextType {
  isViewingMessages: boolean;
  activeConnectionId: string | null;
  setIsViewingMessages: (value: boolean) => void;
  setActiveConnectionId: (id: string | null) => void;
}

const MessagesActiveContext = createContext<MessagesActiveContextType>({
  isViewingMessages: false,
  activeConnectionId: null,
  setIsViewingMessages: () => {},
  setActiveConnectionId: () => {},
});

export const useMessagesActive = () => useContext(MessagesActiveContext);

export const MessagesActiveProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isViewingMessages, setIsViewingMessages] = useState(false);
  const [activeConnectionId, setActiveConnectionId] = useState<string | null>(null);

  return (
    <MessagesActiveContext.Provider value={{
      isViewingMessages,
      activeConnectionId,
      setIsViewingMessages,
      setActiveConnectionId,
    }}>
      {children}
    </MessagesActiveContext.Provider>
  );
};
